import React, { FC } from 'react';
import AskBeforeLeave from 'components/Modals/AskBeforeLeaveForm';

import { Formik } from 'formik';
import BrandSelect from 'components/Form/BrandSelect';
import Loader from 'components/Loaders/SettingsWorkingHours';
import ModalUpdate from 'components/Modals/ModalUpdate';
import { Modal as AskModal } from 'components/Modals/AskYesNo';
import BusyModeModal from 'components/Modals/BusyModeModal';
import { Header, Tabs, Tab, Filters, Button } from '../styles';
import useConnect from './connect';
import {
  Container,
  Row,
  Content,
  Day,
  Status,
  Timing,
  Time,
  StatusCircle,
  StatusText,
  Form,
  Title,
  // SpanRight,
} from './styles';
import { initialValues } from './constants';
// import { Switch } from 'components/TopBar/DrawerStatus/IntegrationStatus/styles';

const WorkingHours: FC = () => {
  const {
    selectedBrandId,
    selectedBrandName,
    setSelectedBrandId,
    workingHours,
    showModal,
    setShowModal,
    showBusyModeModal,
    setShowBusyModeModal,
    handleSubmitModalUpdate,
    formRef,
    handleConfirmSubmit,
    modalIsOpen,
    handleCloseModal,
    handleYesModal,
    handleNoModal,
    // busyModeChecked,
    setBusyModeChecked,
    brandsCount,
    // handleBusyModeOpen,
  } = useConnect();

  return (
    <>
      <AskModal
        message={`Would you like to apply this change to all ${brandsCount} of your virtual brands?`}
        open={modalIsOpen}
        onClose={handleCloseModal}
        onYes={handleYesModal}
        onNo={handleNoModal}
      />
      <Formik
        // @ts-ignore
        innerRef={formRef}
        onSubmit={handleSubmitModalUpdate}
        enableReinitialize
        initialValues={workingHours || initialValues}
        validateOnMount
        validate={() => {
          return {};
        }}
      >
        {({ values, isSubmitting, isValid }) => (
          <Form noValidate>
            <AskBeforeLeave />
            <Header>
              <Tabs>
                <Tab label="General" to="/settings/general" />
                <Tab label="Working Hours" to="/settings/working-hours" />
                <Tab label="Banking & Legal" to="/settings/banking-legal" />
              </Tabs>
              <Filters>
                <BrandSelect
                  value={selectedBrandId}
                  setSelectedId={setSelectedBrandId}
                  allowAllOption={false}
                />
                <Button
                  color="secondary"
                  type="button"
                  onClick={handleConfirmSubmit}
                  disabled={isSubmitting || !isValid}
                >
                  Publish
                </Button>
              </Filters>
            </Header>
            {showModal.open && (
              <ModalUpdate
                title={showModal.title}
                selectedDay={showModal.selectedDay}
                setShowModal={setShowModal}
              />
            )}
            {showBusyModeModal.open && (
              <BusyModeModal
                brandId={selectedBrandId}
                open
                handleClose={(submitted: boolean) => {
                  setShowBusyModeModal({
                    brandId: selectedBrandId,
                    open: false,
                  });
                  if (submitted) {
                    setBusyModeChecked(true);
                  }
                }}
              />
            )}
            <Title>
              {selectedBrandName} working hours
              {/* <SpanRight>
                BUSY MODE
                <Switch
                  checked={busyModeChecked}
                  onChange={() => {
                    if (busyModeChecked) {
                      handleBusyModeOpen(selectedBrandId).then(() =>
                        setBusyModeChecked(false),
                      );
                    } else {
                      setShowBusyModeModal({
                        brandId: selectedBrandId,
                        open: true,
                      });
                    }
                  }}
                />
              </SpanRight> */}
            </Title>
            <Container>
              {!workingHours ? (
                <Loader opacity={1} />
              ) : (
                <Row
                  onClick={() =>
                    setShowModal({
                      open: true,
                      title: 'monday',
                      selectedDay: values.hoursSettings.monday,
                    })
                  }
                >
                  <Content>
                    <Day>Monday</Day>
                    <Status>
                      <StatusCircle
                        status={values.hoursSettings.monday.open ? 'on' : 'off'}
                      />{' '}
                      <StatusText>
                        {values.hoursSettings.monday.open ? 'Open' : 'Closed'}
                      </StatusText>
                    </Status>
                    {values.hoursSettings.monday.open &&
                      values.hoursSettings.monday.timings &&
                      values.hoursSettings.monday.timings.map((timing, i) => {
                        return (
                          <Timing key={`monday${i.toString()}`}>
                            <Time>
                              {timing.timeStart.hours}:
                              {timing.timeStart.minutes}{' '}
                              {timing.timeStart.timeZone}
                            </Time>
                            <Time>
                              {timing.timeEnd.hours}:{timing.timeEnd.minutes}{' '}
                              {timing.timeEnd.timeZone}
                            </Time>
                          </Timing>
                        );
                      })}
                  </Content>
                </Row>
              )}

              {!workingHours ? (
                <Loader opacity={0.8} />
              ) : (
                <Row
                  onClick={() =>
                    setShowModal({
                      open: true,
                      title: 'tuesday',
                      selectedDay: values.hoursSettings.tuesday,
                    })
                  }
                >
                  <Content>
                    <Day>Tuesday</Day>
                    <Status>
                      <StatusCircle
                        status={
                          values.hoursSettings.tuesday.open ? 'on' : 'off'
                        }
                      />{' '}
                      <StatusText>
                        {values.hoursSettings.tuesday.open ? 'Open' : 'Closed'}
                      </StatusText>
                    </Status>

                    {values.hoursSettings.tuesday.open &&
                      values.hoursSettings.tuesday.timings &&
                      values.hoursSettings.tuesday.timings.map((timing, i) => {
                        return (
                          <Timing key={`tuesday${i.toString()}`}>
                            <Time>
                              {timing.timeStart.hours}:
                              {timing.timeStart.minutes}{' '}
                              {timing.timeStart.timeZone}
                            </Time>
                            <Time>
                              {timing.timeEnd.hours}:{timing.timeEnd.minutes}{' '}
                              {timing.timeEnd.timeZone}
                            </Time>
                          </Timing>
                        );
                      })}
                  </Content>
                </Row>
              )}

              {!workingHours ? (
                <Loader opacity={0.6} />
              ) : (
                <Row
                  onClick={() =>
                    setShowModal({
                      open: true,
                      title: 'wednesday',
                      selectedDay: values.hoursSettings.wednesday,
                    })
                  }
                >
                  <Content>
                    <Day>Wednesday</Day>
                    <Status>
                      <StatusCircle
                        status={
                          values.hoursSettings.wednesday.open ? 'on' : 'off'
                        }
                      />{' '}
                      <StatusText>
                        {values.hoursSettings.wednesday.open
                          ? 'Open'
                          : 'Closed'}
                      </StatusText>
                    </Status>
                    {values.hoursSettings.wednesday.open &&
                      values.hoursSettings.wednesday.timings &&
                      values.hoursSettings.wednesday.timings.map(
                        (timing, i) => {
                          return (
                            <Timing key={`wednesday${i.toString()}`}>
                              <Time>
                                {timing.timeStart.hours}:
                                {timing.timeStart.minutes}{' '}
                                {timing.timeStart.timeZone}
                              </Time>
                              <Time>
                                {timing.timeEnd.hours}:{timing.timeEnd.minutes}{' '}
                                {timing.timeEnd.timeZone}
                              </Time>
                            </Timing>
                          );
                        },
                      )}
                  </Content>
                </Row>
              )}

              {!workingHours ? (
                <Loader opacity={0.4} />
              ) : (
                <Row
                  onClick={() =>
                    setShowModal({
                      open: true,
                      title: 'thursday',
                      selectedDay: values.hoursSettings.thursday,
                    })
                  }
                >
                  <Content>
                    <Day>Thursday</Day>
                    <Status>
                      <StatusCircle
                        status={
                          values.hoursSettings.thursday.open ? 'on' : 'off'
                        }
                      />{' '}
                      <StatusText>
                        {values.hoursSettings.thursday.open ? 'Open' : 'Closed'}
                      </StatusText>
                    </Status>
                    {values.hoursSettings.thursday.open &&
                      values.hoursSettings.thursday.timings &&
                      values.hoursSettings.thursday.timings.map((timing, i) => {
                        return (
                          <Timing key={`thursday${i.toString()}`}>
                            <Time>
                              {timing.timeStart.hours}:
                              {timing.timeStart.minutes}{' '}
                              {timing.timeStart.timeZone}
                            </Time>
                            <Time>
                              {timing.timeEnd.hours}:{timing.timeEnd.minutes}{' '}
                              {timing.timeEnd.timeZone}
                            </Time>
                          </Timing>
                        );
                      })}
                  </Content>
                </Row>
              )}

              {!workingHours ? (
                <Loader opacity={0.2} />
              ) : (
                <Row
                  onClick={() =>
                    setShowModal({
                      open: true,
                      title: 'friday',
                      selectedDay: values.hoursSettings.friday,
                    })
                  }
                >
                  <Content>
                    <Day>Friday</Day>
                    <Status>
                      <StatusCircle
                        status={values.hoursSettings.friday.open ? 'on' : 'off'}
                      />{' '}
                      <StatusText>
                        {values.hoursSettings.friday.open ? 'Open' : 'Closed'}
                      </StatusText>
                    </Status>
                    {values.hoursSettings.friday.open &&
                      values.hoursSettings.friday.timings &&
                      values.hoursSettings.friday.timings.map((timing, i) => {
                        return (
                          <Timing key={`friday${i.toString()}`}>
                            <Time>
                              {timing.timeStart.hours}:
                              {timing.timeStart.minutes}{' '}
                              {timing.timeStart.timeZone}
                            </Time>
                            <Time>
                              {timing.timeEnd.hours}:{timing.timeEnd.minutes}{' '}
                              {timing.timeEnd.timeZone}
                            </Time>
                          </Timing>
                        );
                      })}
                  </Content>
                </Row>
              )}

              {!workingHours ? (
                <Loader opacity={0} />
              ) : (
                <Row
                  onClick={() =>
                    setShowModal({
                      open: true,
                      title: 'saturday',
                      selectedDay: values.hoursSettings.saturday,
                    })
                  }
                >
                  <Content>
                    <Day>Saturday</Day>
                    <Status>
                      <StatusCircle
                        status={
                          values.hoursSettings.saturday.open ? 'on' : 'off'
                        }
                      />{' '}
                      <StatusText>
                        {values.hoursSettings.saturday.open ? 'Open' : 'Closed'}
                      </StatusText>
                    </Status>
                    {values.hoursSettings.saturday.open &&
                      values.hoursSettings.saturday.timings &&
                      values.hoursSettings.saturday.timings.map((timing, i) => {
                        return (
                          <Timing key={`saturday${i.toString()}`}>
                            <Time>
                              {timing.timeStart.hours}:
                              {timing.timeStart.minutes}{' '}
                              {timing.timeStart.timeZone}
                            </Time>
                            <Time>
                              {timing.timeEnd.hours}:{timing.timeEnd.minutes}{' '}
                              {timing.timeEnd.timeZone}
                            </Time>
                          </Timing>
                        );
                      })}
                  </Content>
                </Row>
              )}

              {!workingHours ? (
                <Loader opacity={0} />
              ) : (
                <Row
                  onClick={() =>
                    setShowModal({
                      open: true,
                      title: 'sunday',
                      selectedDay: values.hoursSettings.sunday,
                    })
                  }
                >
                  <Content>
                    <Day>Sunday</Day>
                    <Status>
                      <StatusCircle
                        status={values.hoursSettings.sunday.open ? 'on' : 'off'}
                      />{' '}
                      <StatusText>
                        {values.hoursSettings.sunday.open ? 'Open' : 'Closed'}
                      </StatusText>
                    </Status>

                    {values.hoursSettings.sunday.open &&
                      values.hoursSettings.sunday.timings &&
                      values.hoursSettings.sunday.timings.map((timing, i) => {
                        return (
                          <Timing key={`sunday${i.toString()}`}>
                            <Time>
                              {timing.timeStart.hours}:
                              {timing.timeStart.minutes}{' '}
                              {timing.timeStart.timeZone}
                            </Time>
                            <Time>
                              {timing.timeEnd.hours}:{timing.timeEnd.minutes}{' '}
                              {timing.timeEnd.timeZone}
                            </Time>
                          </Timing>
                        );
                      })}
                  </Content>
                </Row>
              )}
            </Container>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default WorkingHours;
